"use client";
import { useState, useEffect } from "react";
import breakpoints from "@c4c-web/tailwind-config";
import { isClient } from "../libs";

type TBreakpoints = Record<string, string>;

export enum EScreenSize {
  Mobile = "mobile",
  Tablet = "tablet",
  TabletLarge = "tabletLarge",
  Desktop = "desktop",
}

interface IScreenSize {
  isMobile: boolean;
  isTablet: boolean;
  isLargeTablet: boolean;
  isDesktop: boolean;
}

export const numericBreakpoints = Object.values(
  (breakpoints as { theme?: { screens?: TBreakpoints } }).theme?.screens || {},
).map((value: string) => Number(value.replace("px", "")));

export const getScreenSize = (width: number): EScreenSize => {
  if (width < numericBreakpoints[1]) {
    return EScreenSize.Mobile;
  } else if (width < numericBreakpoints[2]) {
    return EScreenSize.Tablet;
  } else if (width < numericBreakpoints[3]) {
    return EScreenSize.TabletLarge;
  }
  return EScreenSize.Desktop;
};

export const useScreenSize = (): IScreenSize => {
  const [screenSize, setScreenSize] = useState(
    isClient() ? getScreenSize(window.innerWidth) : EScreenSize.Desktop,
  );

  useEffect(() => {
    if (!isClient()) {
      return;
    }

    const handleResize = (): void => {
      setScreenSize(getScreenSize(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return {
    isMobile: screenSize === EScreenSize.Mobile,
    isTablet: screenSize === EScreenSize.Tablet,
    isLargeTablet: screenSize === EScreenSize.TabletLarge,
    isDesktop: screenSize === EScreenSize.Desktop,
  };
};
